import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import renderIf from 'render-if';
import {routes} from "../../util/config";
import TableGrid from "../../components/TableGrid/TableGrid";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faUsers,faPlus} from "@fortawesome/free-solid-svg-icons";
import {removeTokenUserStorage, setAlertOnRedux, validRemoveTokenUserStorage} from "../../actions";
import {alertLabels, labels, messages} from "../../util/constants";
import Filter from "../../components/filter/Filter";
import './users.css';
import {Button} from "@material-ui/core/umd/material-ui.production.min";
import httpHttpsRequest from '../../util/http-request/request';
import { getUserProfileDriverOptions, deleteUserOptions } from '../../util/optionsRequest';

class Users extends Component {

    constructor(props){
        super(props);
        this.state ={
            data : []
        }
        this.options = {
            sortName: ['user_name'],
            sortOrder: ['asc'],
        };
    };

    componentWillMount(){
        this.getDataUsers({});
    };
    
    getDataUsers=(params)=>{
        let http = new httpHttpsRequest(getUserProfileDriverOptions);
        http.addQueryString(params);

        http.makeRequest().then((data)=>{this.usersSuccess(JSON.parse(data))})
            .catch((data)=>{this.callBackError(data)})
    };

    disableUser=(id_user)=>{
        let params ={id_user};

        let http = new httpHttpsRequest(deleteUserOptions);
        http.addQueryString(params);

        http.makeRequest().then((data)=>{this.userDisabled(JSON.parse(data))})
            .catch((data)=>{this.callBackError(data)})
    };

    userDisabled = (response) =>{
        try{
            if(response != null && response.success == true){
                this.getDataUsers();
                setAlertOnRedux(true,alertLabels.iconSuccess,messages.userDisabled, alertLabels.alertSuccess);
            }else{
                setAlertOnRedux(true,alertLabels.iconError,response.message, alertLabels.alertDanger);
            }
        }catch(err){
            setAlertOnRedux(true,alertLabels.iconError,response.requestErrorDefault, alertLabels.alertDanger);
        }

    };

    usersSuccess = (response) =>{
        if(response.data && response.data.length > 0){
            this.setState({data:response.data});
        }else{
            this.setState({data:response.data});
            setAlertOnRedux(true,alertLabels.iconInfo,messages.emptyData, alertLabels.alertInfo);
        }

    };

    callBackError = (response) => {
        try {
            if (validRemoveTokenUserStorage(response.statusCode)) {
                removeTokenUserStorage();
            }
            setAlertOnRedux(true, alertLabels.iconError, JSON.parse(response.body).message, alertLabels.alertDanger);
        }catch(err){
            setAlertOnRedux(true, alertLabels.iconError, messages.requestErrorDefault,alertLabels.alertDanger);
        }
    };

    redirectToUserControl = (data) =>{

        let user_date = {...data};
        this.props.history.push({
            pathname: routes.userControl,
            state: { detail: user_date }
        })
    };

    redirectToNewUser = () =>{
        this.props.history.push({pathname: routes.userControl})
    };
    
    render() {
        return (
            <div className="container users">
                <h1 className='title'>{'\u00A0'} <FontAwesomeIcon icon={faUsers} />{'\u00A0'} {labels.users}</h1>

                <Filter search={this.getDataUsers}/>
                <div className={'newUser'}>
                    <Button variant="contained"  color="primary" onClick={()=>{this.redirectToNewUser()}}>
                        <FontAwesomeIcon icon={faPlus} /> &nbsp;&nbsp;{labels.newUser}
                    </Button>
                </div>
                {
                    renderIf(this.state.data.length > 0)
                    (
                        <TableGrid options={this.options} data={this.state.data} redirectToUserControl={this.redirectToUserControl} disableUser={this.disableUser}/>
                    )
                }
            </div>
        )
    }
}

export default withRouter(Users);


// WEBPACK FOOTER //
// ./src/containers/users/users.js